import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/shared/lib/utils'

export type PackagingComplianceProgressBadgeVariant =
  | 'danger'
  | 'warning'
  | 'success'

export function getPackagingComplianceProgressBadgeVariant(
  completed: number,
  total: number
): PackagingComplianceProgressBadgeVariant {
  const allComplete = total > 0 && completed >= total
  if (allComplete) {
    return 'success'
  }
  if (completed === 0) {
    return 'danger'
  }
  return 'warning'
}

type PackagingComplianceProgressBadgeProps = {
  completed: number
  total: number
}

export function PackagingComplianceProgressBadge({
  completed,
  total,
}: PackagingComplianceProgressBadgeProps) {
  const { t } = useTranslation('packagingSuppliers')
  const variant = getPackagingComplianceProgressBadgeVariant(completed, total)

  let badgeVariant: 'destructive' | 'warning' | 'outline' = 'warning'
  let className: string | undefined

  if (variant === 'success') {
    badgeVariant = 'outline'
    className = 'border-green-200 bg-green-50 text-green-700'
  } else if (variant === 'danger') {
    badgeVariant = 'destructive'
  } else {
    badgeVariant = 'warning'
  }

  let label = t('list.complianceProgressBadge.ratio', {
    completed,
    total,
  })
  if (variant === 'success') {
    label = t('list.complianceProgressBadge.allCompleted')
  }

  return (
    <Badge variant={badgeVariant} className={cn(className)}>
      {label}
    </Badge>
  )
}
